<template>
  <div class="modal" @keydown.esc="primaryBtnAction" ref="modal">
    <div class="modal__container">
      <p class="small-headline">Uh oh!</p>

      <h1 class="extra-large-headline">
        {{ modalStore.dofpModal.options.title }}
      </h1>

      <p class="bodycopy" v-html="modalStore.dofpModal.options.body" />

      <ButtonBase @click.prevent="primaryBtnAction">{{
        modalStore.dofpModal.options.primaryBtnText
      }}</ButtonBase>

      <ButtonBase
        @click.prevent="secondaryBtnAction"
        v-if="modalStore.dofpModal.options?.secondaryBtnText"
      >{{ modalStore.dofpModal.options.secondaryBtnText }}</ButtonBase
      >
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import gsap from 'gsap';

import { useModalStore } from '@/stores/components/modalStore';

import ButtonBase from '@/components/ui/buttons/ButtonBase.vue';
import { useGlobalStore } from '@/stores/globalStore';

const globalStore = useGlobalStore();
const modalStore = useModalStore();
const modal = ref(null);
const $emit = defineEmits(['onPrimaryButtonClick']);

const primaryBtnAction = () => $emit('onPrimaryButtonClick');
const secondaryBtnAction = () => {
  const { returnUrl } = globalStore.getMerchantSettings;
  window.top.location.href = returnUrl;
};

onMounted(() => {
  modal.value.focus();

  const successTl = gsap.timeline();
  successTl.fromTo(
    '.modal',
    {
      duration: 0.75,
      y: 30,
      opacity: 0,
    },
    {
      y: 0,
      opacity: 1,
      delay: 0.5,
      ease: 'inOut.power3',
    },
  );
});
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 1.5rem 2.25rem;
    background: var(--modal-content-background);
    border-radius: $border-radius;

    @include breakpoint($min-m) {
      padding: 3rem;
      max-width: 468px;
    }

    .bodycopy {
      margin-bottom: 1.8rem;
      @include breakpoint($max-m) {
        line-height: 1.7;
      }
    }

    .button {
      margin-bottom: 1rem;
    }

    .small-headline {
      color: var(--primary);
      margin-bottom: 1.8rem;
    }
  }
}
</style>
